import { GraphQLClient } from "graphql-request";

import Config from "~/config";
import offlineRequestMiddleware from "~/helpers/offline/offlineRequestMiddleware";
import getHeaders from "~/services/graphqlHeaders";

const intelligenceClient = new GraphQLClient(Config.intelligenceEndpoint, {
	credentials: "omit",
	headers: () => getHeaders(),
	mode: "cors",
	requestMiddleware: offlineRequestMiddleware
});

export default intelligenceClient;
